import { render, staticRenderFns } from "./trade_bill.vue?vue&type=template&id=7f708ff3&scoped=true&"
import script from "./trade_bill.vue?vue&type=script&lang=js&"
export * from "./trade_bill.vue?vue&type=script&lang=js&"
import style0 from "./trade_bill.vue?vue&type=style&index=0&id=7f708ff3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f708ff3",
  null
  
)

export default component.exports